import '../styles/TechnologiesMore.scss'
import {Row, Col} from "react-simple-flex-grid";
import {Chip} from "./Chip";

export const TechnologiesCloud = () => {
    const metaHumanChipsList = ['e-commerce', 'e-learning', 'finance', 'media & entertainment', 'security']

    return <>
        <Row>
            <Col xs={12} sm={6}>
                <h3 className="section-title">
                    Cloud
                </h3>
                <h5 className="section-subtitle">
                    Neural network & website hosting = real-time + multifunctional + secure
                </h5>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <div className="cloud-animation-container">
                    <div className="cloud-animation-description">
                        <p>
                            To generate visitor's avatars which we also securely mint as NFT in real-time, we run neural
                            network on Azure Cloud.
                        </p>
                        <div className="cloud-animation-chips">
                            <div className="chips-container small-chips">
                                {metaHumanChipsList.length && metaHumanChipsList.map((item: string, index) => {
                                    return <Chip key={index} chip={item}/>
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </Col>
        </Row>
    </>
}